import React from 'react';
import { motion } from 'framer-motion';
import { Award } from 'lucide-react';
export function DiferencialSection() {
  return <section className="w-full bg-motor-red py-14 px-4 sm:px-6 lg:px-8 relative overflow-hidden" data-id="element-57">
      <div className="absolute inset-0 opacity-10" data-id="element-58">
        <div className="absolute inset-0 metal-texture" data-id="element-59"></div>
      </div>

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-60">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center space-y-6" data-id="element-61">
          <div className="flex justify-center" data-id="element-62">
            <div className="w-20 h-20 bg-white/20 rounded-full flex items-center justify-center border-4 border-white" data-id="element-63">
              <Award className="w-10 h-10 text-white" data-id="element-64" />
            </div>
          </div>

          <h2 className="font-bebas text-4xl sm:text-5xl lg:text-6xl text-white uppercase leading-tight" data-id="element-65">
            No es teoría.
            <br data-id="element-66" />
            Es experiencia real aplicada paso a paso.
          </h2>

          <p className="text-lg sm:text-xl text-white/90 font-montserrat font-semibold max-w-3xl mx-auto" data-id="element-67">
            Métodos probados en cientos de motores, explicados de forma simple y
            directa
          </p>
        </motion.div>
      </div>
    </section>;
}